import React from "react";
import { Route } from "react-router-dom";
import InvestorAftercareDashboard from "../../../pages/Views/OperationAndManagement/InvestorAftercareDashboard";
import RegisterNewInvestor from "../../../pages/Views/OperationAndManagement/Forms/RegisterNewInvestor";
import TransferPropertyForm from "../../../pages/Views/OperationAndManagement/Forms/TransferPropertyForm";
import RegisterAgreement from "../../../pages/Views/OperationAndManagement/Forms/RegisterAgreement";
import AgreementManagement from "../../../pages/Views/OperationAndManagement/Forms/AgreementManagement";
//******************************************** */
import RenewAgreement from "../../../pages/Views/OperationAndManagement/Forms/RenewalManagement";
import InvestorAfterCareReport2 from "../../../pages/Views/OperationAndManagement/Reports/InvestorAfterCareReport2";
import EmploymentReport from "../../../pages/Views/OperationAndManagement/Reports/EmploymentReport";
import TradeReport from "../../../pages/Views/OperationAndManagement/Reports/TradeReport";
//******************************************** */
import ParcelListAll from "../../../pages/Views/Shared/Report/List/ParcelListAll";

import {
	ArrearReports,
	ArrearReport2,
	FinancialReport2,
	PaymentsDueAlert,
	UncollectedReport,
	FinancialSummaryReport,
	RevenueReport,
	RevenueReport2,
} from "../../../pages/Views/CorporateResource/FinanceView/Reports";
import RegisterInvestorActivities from "../../../pages/Views/OperationAndManagement/Forms/RegisterInvestorActivities";
import InvestorListAll from "../../../pages/Views/Shared/Report/List/InvestorListAll";
import Rental_rate from "../../../pages/Views/OperationAndManagement/Forms/Rental_rate";
import InvAftercareReport from "../../../pages/Views/OperationAndManagement/Reports/InvAftercareReport";
import ImportExistingTenant from "../../../pages/Views/OperationAndManagement/Forms/ImportExistingTenant";
import InvAftercareSettings from "../../../pages/Views/OperationAndManagement/Forms/InvAftercareSettings";
import RegisterTerminationRequest from "../../../pages/Views/OperationAndManagement/Forms/RegisterTerminationRequest";
import { ParksDetailByOccupancy, ParksDetailBySector } from "../../../pages/Views/ExecutiveView/DashboardDetail";
// import { FinancialSummaryReport } from "../../../pages/Views/CorporateResource/FinanceView/Reports";
import ExecActivities from "../../../pages/Views/ExecutiveView/Reports/ExecActivities";
import AgreementManagementPage from "../../../pages/Views/OperationAndManagement/Forms/AgreementManagementPage";
import ViewReferredStatus from "../../../pages/Views/EICView/Forms/ViewReferredStatus";
import ViewMapByCategoryPage from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/Views/ViewMapByCategoryPage";
export default function InvestorAftercareRoutes() {
  return (
    <>
      <Route path="/" element={<InvestorAftercareDashboard />} />
      <Route path="/registerInvestor" element={<RegisterNewInvestor />} />
      {/* <Route path="/registerAgreement" element={<RegisterAgreement />} /> */}
      {/* **** */}
       <Route path="/registerAgreement" element={<AgreementManagement />} />
       <Route path="/arrear" element={<ArrearReport2 />} /> 
      {/* **** */}
      {/* ****************************** */}
      <Route path="/renewAgreement" element={<RenewAgreement />} />
      {/* ***************************** */}
      <Route path="/registerTerminationRequest" element={<RegisterTerminationRequest />} />
      <Route path="/investorActivities" element={<RegisterInvestorActivities />} />
      {/* <Route path="/investorList" element={<InvestorList />} /> */}
      <Route path="/employment" element={<EmploymentReport />} />
      <Route path="/investorList" element={<InvestorListAll />} />
      <Route path="/agreementList" element={<AgreementManagementPage />} />
      
      <Route path="/parcelList" element={<ParcelListAll />} />
      
      <Route path="/tradereport" element={<TradeReport />} />
      <Route path="/investorReport" element={<InvestorAfterCareReport2 />} />
      <Route path="/importTenant" element={<ImportExistingTenant />} />
      <Route path="/invAftercareReport" element={<InvAftercareReport />} />
      <Route path="/invAftercareSettings" element={<InvAftercareSettings />} />
      <Route path="/transferProperty" element={<TransferPropertyForm />} />
      <Route path="/parksByOccupancy" element={<ParksDetailByOccupancy />} />
      <Route path="/parksByIndustry" element={<ParksDetailBySector />} />
      <Route path="/financeSummary" element={<FinancialSummaryReport />} />
      <Route path="/execActivities" element={<ExecActivities />} />
      <Route path="/rentRateTable" element={<Rental_rate/>} />

      <Route path="/viewReferredStatus" element={<ViewReferredStatus />} />

      <Route path="/viewMapByCategory" element={<ViewMapByCategoryPage />} />
    </>
  );
}
